export const SHOP_US_HOST = 'shop-us.sunlighten.com';

export function getValidReferralCode(
    value: string | null | undefined
): string | undefined {
    return value && value !== 'null' && value !== 'undefined'
        ? value
        : undefined;
}

export function buildShopUsDiscountUrl(
    originalUrl: string,
    code: string
): string {
    if (!originalUrl || !code) return originalUrl;

    let url: URL;
    try {
        url = new URL(originalUrl, 'https://www.sunlighten.com');
    } catch {
        return originalUrl;
    }

    if (
        url.hostname !== SHOP_US_HOST ||
        !['http:', 'https:'].includes(url.protocol) ||
        url.pathname.startsWith('/discount/')
    ) {
        return originalUrl;
    }

    const discountUrl = `https://${SHOP_US_HOST}/discount/${encodeURIComponent(
        code
    )}`;
    if (url.pathname === '/' && !url.search && !url.hash) {
        return discountUrl;
    }

    const redirect = `${url.pathname}${url.search}${url.hash}`;
    return `${discountUrl}?redirect=${encodeURIComponent(redirect)}`;
}
